import { BaseSerializer } from './base.serializer'
import { TimeSerializer } from './attributes'
import { ExportResult } from 'models/export-result.model'

export class ExportResultSerializer extends BaseSerializer<ExportResult> {
  static DESERIALIZERS = {
    exportDate: TimeSerializer,
    createDate: TimeSerializer,
    lastUpdate: TimeSerializer
  }

  static initializeObject(attributes: Object): ExportResult {
    return new ExportResult(attributes)
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/serializers/export-result.serializeer.ts